import { Column, ScrollArea } from 'components/Blocks';
import { IncentiveProgress } from 'components/Rewards';

import { useLang } from 'locale';
import { useWindowSize } from 'hooks';

import { ActivityHistory } from './ActivityHistory';
import { RewardList } from './Rewards';
import { appConfig } from 'config/app';

export function RewardSection() {
  const { t } = useLang();

  const { breakpoints } = useWindowSize();

  const isMobileView = breakpoints.SMALL_TABLET;

  const content = (
    <Column alignItems="center" className="px-4 pb-4 pt-10" gap="8">
      <IncentiveProgress />

      <p className="max-w-md text-center text-sm">
        {t('redeem-min', { currency: appConfig.defaultCurrency })}
      </p>

      <ActivityHistory />

      <RewardList />
    </Column>
  );

  if (!isMobileView) return <ScrollArea className="h-full">{content}</ScrollArea>;

  return content;
}
